import axios from "axios";
import config from "../../env.json";
import { ResultData } from "../../components/DNSBinding/types"; 

// Redirect URI API
function addRedirectURI(payload: any, callback: any) {
  try {
    // Check if the current path contains /tenants/configure/
    const isTenantConfigurePath = window.location.hash.includes('/tenants/configure/');

    // Use different endpoint based on the path
    const endpoint = isTenantConfigurePath
      ? "/redirect/batch-add-tenant-redirect-uris"
      : "/redirect/batch-add-redirect-uris";

    const requestBody = isTenantConfigurePath
      ? {
          redirectUris: [payload.redirectURI.trim()],
          appRegistrationId: payload.appRegistrationId?.trim() || "b01dd374-e49f-4ac7-931b-0e6e29defe8a",
          uriType: "spa",
          tenantId: payload.clientId,
        }
      : {
          redirectUris: [payload.redirectURI.trim()],
          appRegistrationId: payload.appRegistrationId.trim(),
          clientId: payload.clientId,
        };

    axios
      .post(config.REACT_APP_ENV_API_BASE + endpoint, requestBody)
      .then((res) => {
        callback(res.data);
      })
      .catch(() => {
        callback(null);
      });
  } catch (error) {
    callback(null);
  }
}

// Update DNS
async function updateDNS(payload: { subdomainPrefix: string; clientId: string; clientName: string }): Promise<ResultData> {
  const { data } = await axios.post(`${config.REACT_APP_ENV_API_BASE}/dns/batch-update-from-azure`, payload);
  return data;
}

// Validate DNS
async function validateDNS(payload: { subdomainPrefix: string }): Promise<ResultData> {
  const { data } = await axios.post(`${config.REACT_APP_ENV_API_BASE}/dns/batch-validate-from-azure`, payload);
  return data;
}

// Add Custom Tenant Domain
async function addCustomTenantDomain(payload: {
  subdomainPrefix: string;
  tenantId: string;
  subscriptionId: string;
  resourceGroupName: string;
  tenantName: string;
}): Promise<ResultData> {
  const { data } = await axios.post(`${config.REACT_APP_ENV_API_BASE}/dns/add-custom-tenant-domain`, payload);
  return data;
}

async function configureSuperset(payload: { id: string; name: string }): Promise<ResultData> {
  const { data } = await axios.post(`${config.REACT_APP_ENV_API_BASE}/postProvisioning/superset-provision`, payload);
  return data;

}

export { addRedirectURI, updateDNS, validateDNS, addCustomTenantDomain, configureSuperset };
